import { Component, OnInit,Input,SimpleChanges,Output } from '@angular/core';
import { VoiceBatchService } from '../../../service/voice/voice-batch.service';
import { BatchCalls } from '../../../model/batch-calls'
import { BatchCallDetails } from '../../../model/batch-call-details'
import { LoadedRouterConfig } from '@angular/router/src/config';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { CallHistoryComponent } from '../call-history/call-history.component'
import { CallHistory } from '../voice-detail/call-history'

@Component({
  selector: 'voice-detail-table',
  templateUrl: './voice-detail-table.component.html',
  styleUrls: ['./voice-detail-table.component.scss']
})
export class VoiceDetailTableComponent implements OnInit {

  @Input() batch_id:any;

  ngOnChanges(changes: SimpleChanges) {
    if(changes['batch_id']){
      alert('Batch ID change from table:' + this.batch_id)
      this.getBatchDetails(this.maxItemsPerPage,this.page,this.keyword)
    }
     
  }

  protected maxItemsPerPage: number;
  protected page: number;
  protected total: number;

  protected keyword: string;

  private batch_details:BatchCallDetails[] = [];
  private loading:boolean = false;

  constructor(
    private http:VoiceBatchService,
    private modalService: NgbModal,
  ) {
    this.initializeComponents();
   }

   private initializeComponents() {
    this.maxItemsPerPage = 5;
    this.page = 1;
    this.keyword = '';
  }

  ngOnInit() {
      this.getBatchDetails(this.maxItemsPerPage,this.page,this.keyword)
   }

getBatchDetails(maxItemsPerPage:number,page: number,keyword:string){
  this.loading = true;
  
  const bid = this.batch_id;
  
  this.http.getVoiceDetails(bid,maxItemsPerPage,page,keyword).subscribe(
    (data)=> {
      //this.batch_details = <BatchCallDetails[]>(data['data'])
      this.reassignVariables(data);
    },
    (err) => {
       alert('Loading Failed: ' + JSON.stringify(err))
    },
    () => {
      this.loading = false;
    }
  )
  
 
}

reassignVariables(data){
  this.batch_details = data.data.data;
  this.total = data.data.total;
}


openCallHistory(batch_detail_id) {
  const modRef = this.modalService.open(CallHistory,{size:'lg'});
  modRef.componentInstance.batch_detail_id = batch_detail_id;
 
}

}
